<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="8">
        <v-card class="elevation-12">
          <v-window v-model="step">


            <v-window-item :value="1">
              <v-row>

                <v-col cols="12" md="8">
                  <v-card-text class="mt-12">
                    <h1 class="text-center display-2 green--text text--darken-1">Sign In</h1>
                    <div class="text-center mt-4">
                      <v-btn class="mx-2" fab color="black" outlined>
                        <v-icon>fab fa-facebook-f</v-icon>
                      </v-btn>
                      <v-btn class="mx-2" fab color="black" outlined>
                        <v-icon>fab fa-google-plus-g</v-icon>
                      </v-btn>
                      <v-btn class="mx-2" fab color="black" outlined>
                        <v-icon>fab fa-linkedin-in</v-icon>
                      </v-btn>
                    </div>
                    <h4 class="text-center mlt-4">Ensure your email for registration</h4>
                    <v-form>
                      <v-text-field
                      label="Email"
                      name="Email"
                      prepend-icon="email"
                      type="text"
                      color="green darken-1">

                      </v-text-field>
                      <v-text-field
                      id="password"
                      label="Password"
                      name="Password"
                      prepend-icon="lock"
                      type="password"
                      color="green darken-1"
                      >
                      </v-text-field>
                    </v-form>
                    <h3 class="text-center mt-3">Forgot your passsword?</h3>
                  </v-card-text>
                  <div class="text-center my-3">
                    <v-btn rounded color="green darken-1" dark>Sign In</v-btn>
                  </div>
                </v-col>
                <v-col cols="12" md="4" class="green darken-1">
                  <v-card-text class="white--text mt-12">
                    <h1 class="text-center display-1">Welcome!</h1>
                    <h5 class="text-center">Enter your information to login!</h5>
                  </v-card-text>
                  <div class="text-center">
                    <v-btn rounded outlined dark @click="step++" class="mb-5">Sign Up</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-window-item>



            <v-window-item :value="2">
              <v-row class="fill-height">
                <v-col cols="12" md="4" class="green darken-1">
                  <v-card-text class="white--text mt-12">
                    <h1 class="text-center display-1">Welcome Back!</h1>
                    <h5 class="text-center">To keep connected, please login with your information</h5>
                  </v-card-text>
                  <div class="text-center">
                    <v-btn rounded outlined dark @click="step--">Sign In</v-btn>
                  </div>
                </v-col>
                <v-col cols="12" md='8'>
                  <v-card-text class="mt-12">
                    <h1 class="text-center display-2 green--text text--darken-1">Create Account</h1>
                    <div class="text-center mt-4">
                      <v-btn class="mx-2" fab color="black" outlined>
                        <v-icon>fab fa-facebook-f</v-icon>
                      </v-btn>
                      <v-btn class="mx-2" fab color="black" outlined>
                        <v-icon>fab fa-google-plus-g</v-icon>
                      </v-btn>
                      <v-btn class="mx-2" fab color="black" outlined>
                        <v-icon>fab fa-linkedin-in</v-icon>
                      </v-btn>
                    </div>
                    <h4 class="text-center mt-4">Ensure your email for registration></h4>
                    <v-form>
                      <v-text-field
                      label="Name"
                      name="name"
                      prepend-icon="person"
                      type="text"
                      color="green darken-1" />
                      <v-text-field
                      label="Email"
                      name="Email"
                      prepend-icon="email"
                      type="text"
                      color="green darken-1" />
                      <v-text-field
                      label="Password"
                      name="Password"
                      prepend-icon="lock"
                      type="password"
                      color="green darken-1" />
                    </v-form>
                  </v-card-text>
                  <div class="text-center mb-5">
                    <v-btn rounded color="green darken-1" dark>Sign Up</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-window-item>



          </v-window>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

  export default {
    name: 'Home',

    data: () => ({
      step: 1
    }),
    props: {
      source: String
    }
  };
</script>
